export default __webpack_public_path__ + "static/media/bg5.daf06107.jpg";